import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'emotion';

import theme from 'site-react/theme';

import DesktopNavMenuListItem from './DesktopNavMenuListItem';
import { DesktopNavPanel } from './DesktopNavPanel';
import { NavList } from '../NavList';

const navListStyles = css`
  align-items: center;
  display: flex;

  & li a,
  & li span {
    color: ${theme.colors.neutral900};
    &:hover,
    &:focus {
      color: ${theme.colors.neutral800};
      text-decoration: none;
    }

    &:active {
      color: ${theme.colors.neutral700};
      text-decoration: none;
    }
  }
`;

const navListVerticalStyles = css`
  display: block;
`;

const DesktopNavMenu = ({
  activePanel,
  isLoggedIn,
  isVertical,
  links,
  onNavListItemClick,
  role,
}) => (
  <NavList
    className={cx(navListStyles, {
      [navListVerticalStyles]: isVertical,
    })}
    role={role}
  >
    {links.map((link, index) => (
      <DesktopNavMenuListItem
        isFullWidth={isVertical}
        clickHandler={(e) => onNavListItemClick(e, link)}
        key={`${link.url}-${index + 1}`}
        panel={
          link.panelName ? (
            <DesktopNavPanel
              clickHandler={onNavListItemClick}
              id={`${link.panelName}-panel`}
              panelName={link.panelName}
              visible={link.panelName === activePanel}
            />
          ) : null
        }
        {...link}
      />
    ))}
  </NavList>
);

DesktopNavMenu.defaultProps = {
  activePanel: '',
  isLoggedIn: false,
  isVertical: false,
  onNavListItemClick: null,
};

DesktopNavMenu.propTypes = {
  /**
   * Name of the currently active dropdown panel
   */
  activePanel: PropTypes.string,
  /**
   * Is there a user logged in
   */
  isLoggedIn: PropTypes.bool,
  /**
   * Should the menu be displayed vertically instead of horizontally
   */
  isVertical: PropTypes.bool,
  /**
   * Links for the menu
   */
  links: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * Event for when a link in the menu is clicked
   * Largely used for analytics tracking and opening nav panels.
   */
  onNavListItemClick: PropTypes.func,
  /**
   * Aria role
   * https://a11yproject.com/posts/getting-started-aria/#aria-roles
   */
  role: PropTypes.string.isRequired,
};

export default DesktopNavMenu;
